import { LastMessageSystem } from '@halo/ui-chat-react';
import type { MsgGroupSendMsgMemberContentProps } from './msg-group-send-msg-member-content';
import { MsgGroupSendMsgMemberContent } from './msg-group-send-msg-member-content';

export interface MsgGroupSendMsgMemberPreviewProps extends MsgGroupSendMsgMemberContentProps {}

export const MsgGroupSendMsgMemberPreview = memo(function MsgGroupSendMsgMemberPreview({
  message,
}: MsgGroupSendMsgMemberPreviewProps) {
  return (
    <LastMessageSystem>
      <MsgGroupSendMsgMemberContent message={message} />
    </LastMessageSystem>
  );
});
